import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PoolPointDetailsComponent } from './pool-point-details/pool-point-details.component';
import { PoolAddModalComponent } from './pool-add-modal/pool-add-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { PoolPointActionsCellRendererComponent } from './pool-point-actions-cell-renderer/pool-point-actions-cell-renderer.component';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { EditableCallbackParams } from 'ag-grid-community';


@Component({
  selector: 'app-pool-points',
  templateUrl: './pool-points.component.html',
  styleUrls: ['./pool-points.component.scss']
})
export class PoolPointsComponent implements OnInit {
  pools: any[] = [];
  defaultColDef = { flex: 1, resizable: true };

  detailCellRenderer = PoolPointDetailsComponent;

  columnDefs = [
    {
      headerName: 'Pool Point Name',
      field: 'pool_point_name',
      cellRenderer: 'agGroupCellRenderer',
      editable: (params: EditableCallbackParams<any>) => params.data.isEditable === true
    },
    { headerName: 'Organization Name', field: 'contact_organization' },
    { headerName: 'Address', field: 'address_street' },
    { headerName: 'City', field: 'address_locality' },
    { headerName: 'Province', field: 'address_region' },
    { headerName: 'Country', field: 'address_country' },
    { headerName: 'Postal Code', field: 'address_postal_code' },
    { headerName: 'Actions',
      cellRenderer: PoolPointActionsCellRendererComponent,
      cellRendererParams: {
        onEditClick: (params: any) => this.onEditClick(params)
      }
    },
    // { headerName: 'Actions', sortable: false, suppressMovable: true, suppressHeaderMenuButton: true,
    //   cellRenderer: (params: ICellRendererParams) => {
    //     const editButton = document.createElement('i');
    //     editButton.className = 'fas fa-edit fa-lg';
    //     editButton.style.cursor = 'pointer';
    //     editButton.style.padding = '3px';
    //     editButton.addEventListener('click', () => {})
    //   }
    // }
  ];

  editAction(rowId: any, rowData: any, editButton: HTMLElement, saveButton: HTMLElement, cancelButton: HTMLElement){
    if(typeof rowId === 'number'){

    }
  }

  constructor(private http: HttpClient, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.loadPoolPoints();
  }

  loadPoolPoints(): void {
    // previous url: '/api/pool_points/pool_points.php?name=pool_points'
    this.http
      .get<any>('/api/pool_points/pool_points_ng.php')
      .subscribe(res => {
        this.pools = res.data || [];
      });
  }

  getDetailRowData(params: any): void {
    params.successCallback(params.data);
  }

  addPoolPoint(){
    this.dialog.open(PoolAddModalComponent, {
      width: '400px',
      disableClose: true
    });
  }

  onEditClick(params: any){
    params.data.isEditable = true;
    params.api.refreshCells({ force: true });
    console.log('called onEditClick from main component')
  }
}
